import InfoPage from "../components/InfoPage";

export default function CancellationPolicy() {
    const rows = [
        { when: "24+ hours before slot", penalty: "No penalty", refund: "100% full refund", tone: "good" },
        { when: "Between 24 hrs and 3 hrs before slot", penalty: "50% deducted", refund: "50% refund", tone: "warn" },
        { when: "Within 3 hours of slot start", penalty: "Full amount forfeited", refund: "No refund", tone: "bad" },
        { when: "No-show", penalty: "Full amount forfeited", refund: "No refund", tone: "bad" },
        { when: "Cancelled by Drive or Kick", penalty: "No penalty", refund: "100% full refund", tone: "good" },
    ];
    const toneClass = (t) => t === "good" ? "text-[#00FF66]" : t === "warn" ? "text-amber-400" : "text-red-400";
    return (
        <InfoPage title="Cancellation & Refund Policy" subtitle="Refund amount depends on when you cancel" testid="cancellation-page">
            <div className="overflow-x-auto" data-testid="cancellation-table">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="text-slate-400 text-[10px] uppercase tracking-widest border-b border-slate-800">
                            <th className="text-left py-3 pr-3">When You Cancel</th>
                            <th className="text-left py-3 pr-3">Penalty</th>
                            <th className="text-left py-3">Refund</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r, i) => (
                            <tr key={i} className="border-b border-slate-800/60" data-testid={`policy-row-${i}`}>
                                <td className="py-3 pr-3 text-white">{r.when}</td>
                                <td className="py-3 pr-3 text-slate-300">{r.penalty}</td>
                                <td className={`py-3 font-bold ${toneClass(r.tone)}`}>{r.refund}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <p className="mt-4 text-xs text-slate-500">
                Refunds are credited back to the original payment method via Razorpay and typically arrive within 3–7 business days.
            </p>
        </InfoPage>
    );
}
